import relentless5kIcon from '../../assets/icons/events/relentless_5k.svg'
import teamFormationTipsIcon from '../../assets/icons/events/team_formation_tips.svg'
import { RSVP_RESPONSE, useRSVPEvent } from '../../hooks/events/useRSVPEvent'
import { useUserRSVPs } from '../../hooks/events/useUserRSVPs'
import AppEvent from '../../model/Event'
import { logError } from '../../util/errorLogger'
import EventCard from '../../ui/events/EventCard'

const EVENT_ASSET_MAP: Record<string, string> = {
  'relentless_5k.svg': relentless5kIcon,
  relentless_5k: relentless5kIcon,
  'team_formation_tips.svg': teamFormationTipsIcon,
  team_formation_tips: teamFormationTipsIcon,
}

function resolveEventIcon(eventAsset: string): string | undefined {
  const isUrl = eventAsset.startsWith('http://') || eventAsset.startsWith('https://')
  if (isUrl) return eventAsset
  return EVENT_ASSET_MAP[eventAsset] || EVENT_ASSET_MAP[`${eventAsset}.svg`]
}

interface EventCardContainerProps {
  event: AppEvent
}

export default function EventCardContainer({ event }: EventCardContainerProps) {
  const rsvpMutation = useRSVPEvent()
  const { data: userRSVPs = [] } = useUserRSVPs()
  const hasRSVPd = userRSVPs.some(
    (rsvp) => rsvp.eventID === event.id && rsvp.response === RSVP_RESPONSE,
  )

  function handleAction() {
    if (event.type === 'signup') {
      rsvpMutation.mutate(event.id, {
        onError: (error) =>
          void logError(error, { component: 'EventCard', action: 'RSVP', eventId: event.id }),
      })
    } else if (event.link) {
      window.open(event.link, '_blank')
    }
  }

  return (
    <EventCard
      event={event}
      eventIcon={resolveEventIcon(event.eventAsset)}
      hasRSVPd={hasRSVPd}
      isPending={rsvpMutation.isPending}
      onAction={handleAction}
    />
  )
}
